import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminsService } from 'src/app/services/Admins/admins.service';
import { RouteOptimizationService } from '../../book-tour/route-optimization.service';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';


export interface GetAllproperties {
  tourListingId: number;
  listingMLSId: number;
  name?: string;
  type?: string;
  date?: any;
  timeSlot?: any;
  starttime?: any;
  endtime?: any;
  property?: string;
  status?: string;
  listingAgentName: string;
  imagePathUrl: string;
  address?: string;
  companyName: string;
  tourId: number;
  
}

@Component({
  selector: 'app-tour-requested-sent',
  templateUrl: './tour-requested-sent.component.html',
  styleUrls: ['./tour-requested-sent.component.scss']
})
export class TourRequestedSentComponent implements OnInit {
  tourId: number;
  defaultImageUrl: string = 'https://images.livspace-cdn.com/w:1440/plain/https://d3gq2merok8n5r.cloudfront.net/abhinav/ond-1634120396-Obfdc/jas-1657179080-NnXAg/living-room-1657190512-fE8h4/61-1660297634-FtsXj.jpg';
  center: google.maps.LatLngLiteral = { lat: 39.3999, lng: -8.2245 };
  zoom = 4;
  display: google.maps.LatLngLiteral | undefined;
  routeOptimizationService: RouteOptimizationService;
  optimizedRoute: google.maps.DirectionsResult | null = null;
  coordinates: any[] = [];
  waypoints: google.maps.LatLngLiteral[] = [];
  rendererOptions: google.maps.DirectionsRendererOptions = {
    suppressMarkers: true
  };

  properties: GetAllproperties[] = [];
  //tourId: number;

  constructor(private router: Router, private admn: AdminsService, private route: ActivatedRoute) {

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const tourId = params['tourId'];
      console.log('Tour ID:', tourId);
      this.GetProperties(tourId)
    });
  }




  moveMap(event: google.maps.MapMouseEvent) {
    this.center = (event.latLng!.toJSON());
  }

  move(event: google.maps.MapMouseEvent) {
    this.display = event.latLng!.toJSON();
  }

  gotobook() { this.router.navigate(['/schedule-a-tour']) }


  GetProperties(tourId: number): void {
    this.admn.GetProperties<GetAllproperties[]>(tourId).subscribe(
      (res: GetAllproperties[]) => {
        this.properties = res;
        this.properties.forEach((list: GetAllproperties) => {
          list.starttime = (moment.utc(list.starttime).local().toDate());
          list.endtime = (moment.utc(list.endtime).local().toDate());
        });
            // this.getTodayRequestedListingAddress();
      },
      (err: any) => { }
    );
  }


  getStatusClasses(status: string): string {
    switch (status) {
      case 'Pending':
        return 'pending-class';
      case 'Confirmed':
        return 'confirmed-class';
      case 'Rejected':
        return 'rejected-class';
      case 'Active':
        return 'confirmed-class';
      case 'Cancelled':
        return 'Cancelled-class';
      default:
        return '';
    }
  }

  async getTodayRequestedListingAddress() {
    let promises = this.properties.map(async listing => {
      let a = this.admn.GetListingByTourId(Number(listing.listingMLSId.toString().substr(
        listing.listingMLSId.toString().length - 4,
        listing.listingMLSId.toString().length)));
      return a
    })

    var data = await Promise.all(promises)
    data.forEach(d => {
      d.subscribe((res: any) => {
        this.properties.forEach(props => {
          if (props.listingMLSId.toString() == res.result.systemId) {
            props.address = res?.result?.assetAddress?.streetName
              + " ," + res?.result?.assetAddress?.municipality
              + " ," + res?.result?.assetAddress?.parish + ", " +
              res?.result?.assetAddress?.zone + " ," + res.result?.assetAddress?.zipcode
            //  props.image = res.result.assetFiles[0].physicalPath.includes('https://weumlspnonprodstgdev.blob.core.windows.net/smartrealestateimages') ? "https://weumlspnonprodstgdev.blob.core.windows.net/smartrealestateimages/" + res.result?.assetFiles?.[0]?.relativePath :
              !res.result.assetFiles[0].physicalPath.includes('https://weumlspnonprodstgdev.blob.core.windows.net/smartrealestateimages') ? "https://smartrealestate-api-dev.azurewebsites.net/" + res.result?.assetFiles?.[0]?.relativePath :  this.defaultImageUrl;

          }
        })
      })
    });
  }




}
